import React, { useState } from "react";
import styled from "@emotion/styled";
import { Button, Form, Select, Modal } from "antd";
import { EditOutlined, LeftOutlined, PlusOutlined } from "@ant-design/icons";
import UITable from "../../../Reusablecomponents/UITable/UITable.js";
import Editicon from "../../../assets/images/Editicon.svg";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  background: #f8f9fa;
  padding: 24px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  h2 {
    margin: 0;
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 500;
  }
  .status-tag {
    color: #2e7d32;
    font-weight: 500;
  }
`;

const BackButton = styled(Button)`
  background: #eaf8f0;
  color: #2e7d32;
  border: none;
  &:hover {
    background: #d4f0e0 !important;
    color: #2e7d32 !important;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const RenewButton = styled(Button)`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  font-weight: 500;
  width: 140px;
  &:hover {
    background-color: #236125 !important;
    color: #ffffff !important;
  }
`;

const EditIconButton = styled(Button)`
  border-color: #faad14;
  color: #faad14;
  &:hover {
    border-color: #d48f10 !important;
    color: #d48f10 !important;
  }
`;

const DetailCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px 16px;
  border: 1px solid #f0f0f0;
`;

const DataField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .label {
    color: #8c9ba5;
    font-size: 19px;
  }
  .value {
    color: #2d3748;
    font-size: 17px;
    font-weight: 400;
  }
`;

const LogContainer = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;
  border: 1px solid #f0f0f0;

  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    color: #1f2937;
    font-weight: 500;
  }
`;

const FormWrapper = styled.div`
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
`;

const ModalHeader = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
    font-weight: 500;
  }
  .close-icon {
    cursor: pointer;
    color: #9ca3af;
    font-size: 18px;
  }
`;

const StyledForm = styled(Form)`
  padding-top: 24px;

  .ant-form-item-label > label {
    color: #718096 !important;
    font-size: 13px;
  }

  .ant-select-selector {
    border-radius: 20px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
  }
`;

const UploadZone = styled.div`
  background-color: #eafaf1;
  border: 1px dashed #b2e2c4;
  border-radius: 20px;
  padding: 10px;
  text-align: center;
  color: #2e7d32;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: #d4f5e2;
  }
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
`;

const CancelButton = styled(Button)`
  background-color: #eafaf1;
  color: #2e7d32;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #d4f5e2 !important;
    color: #2e7d32 !important;
  }
`;

const SubmitButton = styled(Button)`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #236125 !important;
    color: #ffffff !important;
  }
`;

const columns = [
  { title: "Start Date", dataIndex: "startDate", key: "startDate" },
  { title: "Expiry Date", dataIndex: "expiryDate", key: "expiryDate" },
  { title: "Provider", dataIndex: "provider", key: "provider" },
  { title: "Type", dataIndex: "type", key: "type" },
  {
    title: "Files",
    dataIndex: "files",
    key: "files",
    render: () => (
      <a href="#view" style={{ color: "#5f6d8c", textDecoration: "underline" }}>
        View
      </a>
    ),
  },
];

const dataSource = Array(5)
  .fill({
    startDate: "20th Feb 2025",
    expiryDate: "20th Feb 2025",
    provider: "Jubilee Insurance",
    type: "Comprehensive",
  })
  .map((item, index) => ({ ...item, key: String(index + 1) }));

const InsuranceDashboard = () => {
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [renewForm] = Form.useForm();
  const [editForm] = Form.useForm();

  const handleRenewSubmit = (values) => {
    console.log("Renew Form Submitted:", values);
    setShowRenewModal(false);
  };

  const handleEditSubmit = (values) => {
    console.log("Edit Form Submitted:", values);
    setShowEditModal(false);
  };

  const detailsData = [
    { label: "Vehicle No", value: "KA12345" },
    { label: "Vehicle Type", value: "Truck" },
    { label: "Model", value: "Axes 100" },
    { label: "Mfg Year", value: "1970" },
    { label: "Internal Dimension of truck", value: "20/20/20" },
    { label: "Cubic Capacity", value: "10,000" },
    { label: "Maximum Load Capacity (in Kg)", value: "20,000" },
    { label: "Fuel Type", value: "Diesel" },
    { label: "Tonnes", value: "-/-" },
    { label: "Link to", value: "-/-" },
    { label: "Status", value: "Active" },
    { label: "Mileage", value: "80" },
    { label: "ODO Reset on", value: "-/-" },
    { label: "Registration Date", value: "24th Aug 2024" },
    { label: "Chassis Number", value: "-/-" },
    { label: "Engine Number", value: "-/-" },
    { label: "Transmission", value: "Manual" },
    { label: "Entity", value: "-/-" },
    { label: "Supplier", value: "-/-" },
    { label: "Driver", value: "-/-" },
    { label: "Type", value: "Comprehensive" },
    { label: "Insurance", value: "Jubilee" },
    { label: "Expiry Date", value: "20th Feb 2025" },
    { label: "Send Expiry Alert Before", value: "1 Week" },
  ];

  const navigate = useNavigate();

  return (
    <>
      <Container>
        <Header>
          <TitleSection>
            <BackButton
              onClick={() => navigate("/Workshop")}
              shape="circle"
              icon={<LeftOutlined />}
            />
            <h2>
              Insurance - KA12345 <span className="status-tag">Valid</span>
            </h2>
          </TitleSection>
          <ActionButtons>
            <RenewButton
              type="primary"
              shape="round"
              onClick={() => setShowRenewModal(true)}
            >
              Renew
            </RenewButton>
            <img
              src={Editicon}
              alt="Editicon"
              onClick={() => setShowEditModal(true)}
            />
          </ActionButtons>
        </Header>

        <DetailCard>
          {detailsData.map((item, index) => (
            <DataField key={index}>
              <span className="label">{item.label}</span>
              <span className="value">{item.value}</span>
            </DataField>
          ))}
        </DetailCard>
      </Container>

      <LogContainer>
        <h3>Insurance Logs</h3>
        <UITable
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{ y: 300 }}
        />
      </LogContainer>

      {/* 1. RENEW MODAL (Image 4) */}
      <Modal
        open={showRenewModal}
        onCancel={() => setShowRenewModal(false)}
        footer={null}
        closable={false}
        width={600}
      >
        <FormWrapper>
          <ModalHeader>
            <h3>KA123</h3>
            <span
              className="close-icon"
              onClick={() => setShowRenewModal(false)}
            >
              ✕
            </span>
          </ModalHeader>

          <StyledForm
            form={renewForm}
            layout="vertical"
            onFinish={handleRenewSubmit}
            initialValues={{
              provider: "Jubilee",
              type: "Comprehensive",
              expiryDate: "20/05/2020",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
              }}
            >
              <Form.Item label="Insurance Provider" name="provider">
                <Select options={[{ value: "Jubilee", label: "Jubilee" }]} />
              </Form.Item>
              <Form.Item label="Insurance Type" name="type">
                <Select
                  options={[{ value: "Comprehensive", label: "Comprehensive" }]}
                />
              </Form.Item>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
              }}
            >
              <Form.Item label="Expiry Date" name="expiryDate">
                <Select
                  options={[{ value: "20/05/2020", label: "20/05/2020" }]}
                />
              </Form.Item>
            </div>

            <UploadZone
              onClick={() => console.log("Trigger file selector interface")}
            >
              <PlusOutlined /> Upload
            </UploadZone>

            <ActionRow>
              <CancelButton onClick={() => setShowRenewModal(false)}>
                Cancel
              </CancelButton>
              <SubmitButton htmlType="submit">Update</SubmitButton>
            </ActionRow>
          </StyledForm>
        </FormWrapper>
      </Modal>

      {/* 2. EDIT INSURANCE MODAL (Image 5) */}
      <Modal
        open={showEditModal}
        onCancel={() => setShowEditModal(false)}
        footer={null}
        closable={false}
        width={1000}
      >
        <FormWrapper>
          <ModalHeader>
            <h3>Edit Insurance</h3>
            <span
              className="close-icon"
              onClick={() => setShowEditModal(false)}
            >
              ✕
            </span>
          </ModalHeader>

          <StyledForm
            form={editForm}
            layout="vertical"
            onFinish={handleEditSubmit}
            initialValues={{
              provider: "Jubilee",
              type: "Comprehensive",
              expiryDate: "12/12/24",
              alertBefore: "1 Week",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "16px",
              }}
            >
              <Form.Item label="Insurance" name="provider">
                <Select options={[{ value: "Jubilee", label: "Jubilee" }]} />
              </Form.Item>
              <Form.Item label="Insurance Type" name="type">
                <Select
                  options={[{ value: "Comprehensive", label: "Comprehensive" }]}
                />
              </Form.Item>
              <Form.Item label="Expiry Date" name="expiryDate">
                <Select options={[{ value: "12/12/24", label: "12/12/24" }]} />
              </Form.Item>
              <Form.Item label="Send Expiry Alert Before" name="alertBefore">
                <Select options={[{ value: "1 Week", label: "1 Week" }]} />
              </Form.Item>
            </div>

            <ActionRow>
              <CancelButton onClick={() => setShowEditModal(false)}>
                Cancel
              </CancelButton>
              <SubmitButton htmlType="submit">Create</SubmitButton>
            </ActionRow>
          </StyledForm>
        </FormWrapper>
      </Modal>
    </>
  );
};

export default InsuranceDashboard;
